import styled from "styled-components";
import logoQr from "../../assets/Images/Qr.svg"
import logoInfo from "../../assets/Images/IconInfo.svg"

const colors = {
  primary: "#FDDA24",
  secondary: "#2C2A29",
  white: "#ffffff",
  disabled: "#D9DADD"
};

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  font-family: "Open Sans";
  font-size: 15px;
  color: #2C2A29;
`;
export const Title = styled.div`
  display: flex;
  font-size: 28px;
  color: #2C2A29;
  text-align: center;
  margin-bottom: 20px;
  line-height: 28px;
  font-family: "CIBFont Sans";

  @media screen and (min-width: 100px) and (max-width: 961px){
    font-size: 24px;
  }
`;

export const DescriptionText = styled.div`
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: ${props => props.marginBottom};
`;

export const DescriptionText2 = styled.div`
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const Conditions = styled.div`
  width: auto;
  justify-content: center;
  margin: 0.5rem 30px;
  text-align: justify;

  @media screen and (max-width: 961px) {
    margin: 60px 23px 0px;
  }
`;
export const Title2 = styled.div`
  font-family: "Open Sans Semibold";
  font-size: 16px;
  letter-spacing: 0px;
  line-height: 24px;
  margin-bottom: ${props => props.marginBottom};
`;

export const ImageQR = styled.div`
  background-image: url(${logoQr});
  background-repeat: no-repeat;
  background-position: center;
  width: auto;
  height: 130px;
`;

export const ContainerToast = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  color: #2C2A29;
  width: 328;
  height: 108;
  gap: 16px;
  border-radius: 8px;
  padding: 16px;
  background-color: #F2F2F4;
`;

export const ImageInfo = styled.div`
  background-image: url(${logoInfo});
  background-repeat: no-repeat;
  background-position: center;
  width: 45px;
  height: 32px;
`;

